export const FETCH_ASSETS_START = 'FETCH_ASSETS_START'
export const FETCH_ASSETS_SUCCESS = 'FETCH_ASSETS_SUCCESS'

// New action types for fetching all assets from root endpoint
export const FETCH_AVAILABLE_ASSETS_START = 'FETCH_AVAILABLE_ASSETS_START'
export const FETCH_AVAILABLE_ASSETS_SUCCESS = 'FETCH_AVAILABLE_ASSETS_SUCCESS'
export const FETCH_AVAILABLE_ASSETS_ERROR = 'FETCH_AVAILABLE_ASSETS_ERROR'

export const FETCH_REFERENCE_CURRENCY_START = 'FETCH_REFERENCE_CURRENCY_START'
export const FETCH_REFERENCE_CURRENCY_SUCCESS = 'FETCH_REFERENCE_CURRENCY_SUCCESS'
export const FETCH_REFERENCE_CURRENCY_ERROR = 'FETCH_REFERENCE_CURRENCY_ERROR'

export const FETCH_DEPOSIT_ADDRESS_START = 'FETCH_DEPOSIT_ADDRESS_START'
export const FETCH_DEPOSIT_ADDRESS_SUCCESS = 'FETCH_DEPOSIT_ADDRESS_SUCCESS'
export const FETCH_DEPOSIT_ADDRESS_ERROR = 'FETCH_DEPOSIT_ADDRESS_ERROR'
